import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Field, inputCls } from "./Field";
import ProductPicker from "./ProductPicker";
import { PrimaryBtn } from "./ui";
import { api, errMsg } from "@/lib/api";

const blank = { platform: "shopee", raw_name: "", raw_variation: "", product_id: "" };

export default function MappingDialog({ open, initial, products, onClose, onSaved }) {
  const [f, setF] = useState(blank);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setF({ ...blank, ...(initial || {}) }); }, [open, initial]);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => {
    setSaving(true);
    try {
      const body = { platform: f.platform, raw_name: f.raw_name, raw_variation: f.raw_variation, product_id: f.product_id };
      if (f.id) await api.put(`/mappings/${f.id}`, body);
      else await api.post("/mappings", body);
      toast.success("Mapping tersimpan");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-xl" data-testid="mapping-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{f.id ? "Ubah Mapping" : "Mapping Produk Marketplace"}</DialogTitle>
          <DialogDescription>Cocokkan nama produk + variasi (tidak case-sensitive) ke produk master.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Field label="Platform" required>
            <Select value={f.platform} onValueChange={set("platform")}>
              <SelectTrigger className="h-12" data-testid="mapping-platform"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="shopee">Shopee</SelectItem><SelectItem value="tokopedia">Tokopedia / TikTok</SelectItem></SelectContent>
            </Select>
          </Field>
          <Field label="Nama produk (raw)" required><Textarea value={f.raw_name} onChange={(e) => set("raw_name")(e.target.value)} data-testid="mapping-raw-name" /></Field>
          <Field label="Variasi" hint="Kosong, “-” atau “Default” = berlaku untuk semua variasi produk ini">
            <input value={f.raw_variation} onChange={(e) => set("raw_variation")(e.target.value)} className={inputCls} data-testid="mapping-raw-variation" />
          </Field>
          <Field label="Produk master" required>
            <ProductPicker products={products} value={f.product_id} onChange={set("product_id")} filter={(p) => p.category !== "Frozen Dough"} testid="mapping-product" />
          </Field>
          <PrimaryBtn className="w-full" onClick={save} disabled={saving || !f.raw_name || !f.product_id} data-testid="mapping-save">{saving ? "Menyimpan…" : "Simpan Mapping"}</PrimaryBtn>
        </div>
      </DialogContent>
    </Dialog>
  );
}
